export const COLLECTION_FEE = 4500;
export const COLLECTION_SURCHARGE = 599;
export const REDELIVER_FEE = 695;
export const REDELIVER_SURCHARGE = 399;
export const SHIPPING_FEE = 2999;
export const FURNITURE_DISASSEMBLY_FEE = 7900;
